import Stack from '@mui/material/Stack';
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import { Button } from '@/components/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
export const BlurModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;

  // backdrop blur
  & .MuiBackdrop-root {
    backdrop-filter: blur(6px);
    background-color: rgba(0, 0, 0, 0.4);
  }
`;

export const InfoStack = styled(Stack)`
  flex-direction: column;
  gap: 24px;
  width: 100%;
  justify-content: center;
`;

export const FormFooter = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  margin-top: 32px;
  padding: 32px;
  padding-top: 0px;
`;

export const StyledButton = styled(Button)`
  height: 32px;
  width: 100%;
`;

export const OptionContainer = styled(Stack)`
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const Label = styled(Typography)`
  font-weight: 500;
  font-size: 12px;
  width: 135px;
`;

export const ContainerBox = styled(Box)`
  max-height: 400px;
  overflow-y: scroll;
  overflow: auto;
  padding: 32px;
  width: 100%;
`;
